import { ChartOptions } from 'chart.js';
import {formatNumber } from "@/helpers";
const defaultOptionsPie: ChartOptions<'pie'> = {
    plugins: {
        legend: {
            display: true,
            position: 'right',
            align: 'center',
            fullSize: false,
            labels: {
                color: '#1e293b',
                textAlign: 'left',
                boxWidth: 20,
                padding: 14,
                usePointStyle: true,
            },
        },
        tooltip: {
            enabled: true,
            callbacks: {
                label: function (context) {
                    let label = context.dataset.label || '';

                    if (label) {
                        label += ': ';
                    }
                    if (context.parsed !== null) {
                        label += formatNumber(context.parsed) + '%';
                    }
                    return label;
                },
            },
        },
        datalabels: {
            color: '#1e293b',
            formatter: (value: any, context: any) => {
                const total = context.chart.data.datasets[0].data.reduce(
                    (acc: number, curr: number) => acc + curr,
                    0
                );
                const percentage = ((value / total) * 100).toFixed(0) + '%';
                return percentage;
            },
            font: {
                weight: 'normal',
                size: 12,
            },
            align: 'end',
            clamp: true,
        },
    },
    responsive: true,
    maintainAspectRatio: false,
};

const defaultColors = [
    '53, 123, 28, 0.25',
    '0, 116, 159, 0.25',
    '115, 199, 115, 0.25',
    '199, 117, 76, 0.25',
    '23, 189, 184, 0.25',
    '254, 192, 202, 0.25',
    '128, 128, 0, 0.25',
    '128, 128, 128, 0.25',
    '210, 105, 30, 0.25',
    '249, 128, 114, 0.25',
    '15, 71, 106, 0.25',
    '167, 93, 177, 0.25',
    '103, 233 , 119, 0.25',
    '215, 62, 198, 0.25',
    '102, 226, 148, 0.25',
    '219, 247, 125, 0.25',
    '34, 95, 117, 0.25',
    '165, 27, 216, 0.25',
    '123, 134, 141, 0.25',
    '168, 29, 28, 0.25',
    '61, 14, 119, 0.25',
    '223, 19, 110, 0.25',
    '124, 25, 171, 0.25',
    '77, 134, 167, 0.25',
    '247, 230, 251, 0.25',
    '49, 3, 184, 0.25',
    '23, 179, 231, 0.25',
    '28, 9, 132, 0.25',
    '61, 124, 133, 0.25',
    '166, 38, 14, 0.25',
    '245, 248, 161, 0.25',
    '171, 15, 147, 0.25',
    '109, 84, 104, 0.25',
    '195, 177, 36, 0.25',
    '66, 18, 159, 0.25',
    '134, 51, 205, 0.25',
    '77, 137, 191, 0.25',
    '72, 33, 16, 0.25',
];

const colorsTop10 = [
    '53, 123, 28',
    '0, 116, 159',
    '115, 199, 115',
    '199, 117, 76',
    '23, 189, 184',
    '254, 192, 202',
    '128, 128, 0',
    '128, 128, 128',
    '210, 105, 30',
    '249, 128, 114',
];

const defaultFillOptions = {
    fill: true,
    fillColor: 'rgb(53 125 66 / 20%)',
    borderColor: 'rgb(53 125 66)',
    tension: 0,
    pointRadius: 0,
};

const defaultOptionsLine = (maxValueY: number): ChartOptions<'line'> => ({
    responsive: true,
    maintainAspectRatio: true,
    indexAxis: 'x',
    plugins: {
        legend: {
            display: false,
        },
        tooltip: {
            enabled: true,
            mode: 'index',
            displayColors: false,
            intersect: false,
            callbacks: {
                label: function (context: any) {
                    let label = context.dataset.label || '';
                    if (label) {
                        label += ': ';
                    }
                    if (context.parsed.y !== null) {
                        label += new Intl.NumberFormat('sv-SE', {}).format(
                            context.parsed.y
                        );
                    }
                    return label;
                },
            },
        },
        datalabels: {
            display: false,
        },
    },
    scales: {
        x: {
            grid: {
                display: false,
            },
        },
        y: {
            suggestedMax: maxValueY,
            beginAtZero: true,
            grid: {
                display: true,
                color: '#f4f4f5',
            },
        },
    },
});

export {defaultOptionsPie, defaultColors, colorsTop10, defaultFillOptions, defaultOptionsLine }